/**
 * Core Preview Contract Index policy flags.
 *
 * Default disabled-by-default policy flags. No real execution, no provider call,
 * no mutation, no write, no smoke execution.
 */
export function createDefaultCorePreviewContractIndexPolicyFlags() {
    return {
        previewOnly: true,
        contractIndexOnly: true,
        realExecutionPerformed: false,
        mutationExecuted: false,
        providerCallExecuted: false,
        externalNetworkEnabled: false,
        approvedExecutionEnabled: false,
        memoryWriteExecuted: false,
        auditWriteExecuted: false,
        fileWriteExecuted: false,
        databaseWriteExecuted: false,
        paymentExecuted: false,
        sendExecuted: false,
        customerRecordUpdated: false,
        embeddingGenerationEnabled: false,
        keyMaterialExposed: false,
        smokeExecuted: false,
    };
}
export function assertCorePreviewContractIndexPolicyCompliance(flags) {
    const checks = [
        ["previewOnly", true],
        ["contractIndexOnly", true],
        ["realExecutionPerformed", false],
        ["mutationExecuted", false],
        ["providerCallExecuted", false],
        ["externalNetworkEnabled", false],
        ["approvedExecutionEnabled", false],
        ["memoryWriteExecuted", false],
        ["auditWriteExecuted", false],
        ["fileWriteExecuted", false],
        ["databaseWriteExecuted", false],
        ["paymentExecuted", false],
        ["sendExecuted", false],
        ["customerRecordUpdated", false],
        ["embeddingGenerationEnabled", false],
        ["keyMaterialExposed", false],
        ["smokeExecuted", false],
    ];
    for (const [key, expected] of checks) {
        if (flags[key] !== expected) {
            throw new Error(`Core preview contract index policy violation: ${key} must be ${expected}`);
        }
    }
}
//# sourceMappingURL=contract-index-policy.js.map